import styled from 'styled-components';
import {
    robotoRegular,
    spanishViridian25,
    spanishViridian500,
    white,
} from '@habitech/shared';
import { Wrapper } from '../calculo-sugeridos/styles';

/**
 * Raíz de la sección de Slots comerciales: reusa el Wrapper compartido pero aplica
 * la tipografía Roboto (igual que el carrito comercial y asignaciones). La fuente
 * se hereda, así que con fijarla en la raíz basta; los íconos (pcom-icon)
 * conservan su propia fuente porque la definen vía su clase.
 */
export const SlotsRoot = styled(Wrapper)`
    font-family: ${robotoRegular};
`;

export const Intro = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 14px;
    border-radius: 10px;
    background: ${spanishViridian25};
    border: 1px solid ${spanishViridian500};
    color: ${spanishViridian500};
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 16px;
`;

export const CardsGrid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
    align-items: start;
    margin-bottom: 16px;

    @media ${({ theme }) => theme.screenSizes.tablet} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const Actions = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 16px;
`;

export const SaveError = styled.div`
    color: #d32f2f;
    font-size: 13px;
    margin-top: 12px;
`;

export const Toast = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    gap: 18px;
    max-width: calc(100% - 32px);
    background: #1f2024;
    color: ${white};
    padding: 12px 18px;
    border-radius: 12px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.28);
    font-size: 14px;
    z-index: 1000;
`;
